const DEFAULT_DATE_FORMAT: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
};

const buildFallbackDate = (
  date: Date,
  options: Intl.DateTimeFormatOptions,
): string => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year =
    options.year === '2-digit'
      ? String(date.getFullYear()).slice(-2)
      : String(date.getFullYear());

  return `${day}/${month}/${year}`;
};

export const formatDateForLocale = (
  value: Date | string | number,
  locale: string,
  options: Intl.DateTimeFormatOptions = DEFAULT_DATE_FORMAT,
): string | undefined => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return undefined;
  }

  try {
    return new Intl.DateTimeFormat(locale, options).format(date);
  } catch {
    return buildFallbackDate(date, options);
  }
};
